import React from "react"
import { Link } from "react-router-dom"
import { reportsPath } from "@/QuarterlyReportApp"

interface BreadcrumbItem {
  label: string
  path?: string
  isActive?: boolean
}

interface BreadcrumbProps {
  communicationId: string
  quarter?: number
  year?: number
  householdName?: string
  householdPath?: string
  sectionName?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  communicationId,
  quarter,
  year,
  householdName,
  householdPath,
  sectionName,
}) => {
  const items: BreadcrumbItem[] = []

  const homeLabel = quarter && year ? `Q${quarter} ${year} Reports` : "Reports"

  if (householdName || sectionName) {
    items.push({
      label: homeLabel,
      path: reportsPath({ communicationId }),
    })
  } else {
    items.push({
      label: homeLabel,
      isActive: true,
    })
  }

  if (householdName) {
    items.push({
      label: householdName,
      path: sectionName && householdPath ? householdPath : undefined,
      isActive: !sectionName,
    })
  }

  if (sectionName) {
    items.push({
      label: sectionName,
      isActive: true,
    })
  }

  if (items.length <= 1) {
    return null
  }

  return (
    <div className="quarterly-reports-breadcrumb-container">
      <nav className="quarterly-reports-breadcrumb">
        {items.map((item, index) => (
          <span key={index} className="quarterly-reports-breadcrumb-item">
            {index > 0 && (
              <span className="quarterly-reports-breadcrumb-separator">
                {" "}
                &lt;{" "}
              </span>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="quarterly-reports-breadcrumb-link"
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={
                  item.isActive
                    ? "quarterly-reports-breadcrumb-current"
                    : "quarterly-reports-breadcrumb-text"
                }
              >
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </div>
  )
}

export default Breadcrumb
